import { saveDeletBrachIdActions } from "./action";

const initialState = {
  deletePartnerBranchData: null,
};

const saveDeleteBranchIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveDeletBrachIdActions.SAVE_DELETE_BRANCH_PERSONID_SUCCESS:
      return {
        ...state,
        deletePartnerBranchData: action.payload.data,
      };
    case saveDeletBrachIdActions.SAVE_DELETE_BRANCH_PERSONID_SUCCESS:
      return {
        ...state,
        deletePartnerBranchData: [],
      };

    default:
      return state;
  }
};

export default saveDeleteBranchIdReducer;
